/**
 * Nettoie le HTML d'une SERP Google avant de l'afficher dans l'iframe de la modale.
 *
 * Le backend (clean_html) masque déjà ces éléments, mais on duplique le nettoyage
 * ici en défense en profondeur. Le bandeau jaune "Ad Preview" de Google Ads est
 * ciblé par son `bgcolor` (#fde293), stable et non localisé, et non par sa classe
 * CSS obfusquée — celle-ci change régulièrement (ex. `cTcgmb` -> `qUK8Ed`).
 */
export default function sanitizeSerpHtml(html: string): string {
    const tempDiv = document.createElement('div');
    tempDiv.innerHTML = html;

    // Masque le bandeau d'avertissement "Ad Preview" de Google Ads.
    tempDiv
        .querySelectorAll('table[bgcolor="#fde293"]')
        .forEach((el) => ((el as HTMLElement).style.display = 'none'));

    // Retire la popup modale (consentement / interstitiel) si présente.
    const popup = tempDiv.querySelector('div[aria-modal="true"]');
    if (popup) popup.remove();

    // Ouvre les liens dans un nouvel onglet et résout l'URL réelle depuis `ping`.
    tempDiv.querySelectorAll('a').forEach((el) => {
        el.removeAttribute('onClick');
        el.setAttribute('target', '_blank');
        const ping = el.getAttribute('ping');
        if (ping) {
            const match = ping.match(/url=([^&]+)/);
            if (match) {
                el.setAttribute('href', decodeURIComponent(match[1]));
            }
        }
    });

    return tempDiv.innerHTML;
}
